import { InjectionToken } from '@angular/core';
import { TransactionsFacade } from './transactions.facade';


export const TRANSACTIONS_FACADE = new InjectionToken<TransactionsFacade>('TRANSACTIONS_FACADE');